import { memo } from 'react';
import { CommonPageType, ICommoDestination } from '../../../domain/CommonPage.domain';
import * as S from './CardViewMore.styles';
import Link from 'next/link';

type CardViewMoreProps = {
    type: CommonPageType;
    destination: ICommoDestination;
};

type TTypes = {
    name: string;
    getPath: (destination: ICommoDestination, type: CommonPageType) => string;
};

const getCommonPath = (destination: ICommoDestination, type: CommonPageType) => {
    return `/${type}/${destination.state.code}/${destination.slug}/`;
};

const TYPES: { [key in CommonPageType]: TTypes } = {
    partners: {
        name: 'Partners',
        getPath: (destination: ICommoDestination, type: CommonPageType) => type && destination.link,
    },
    blog: {
        name: 'Blogs',
        getPath: getCommonPath,
    },
    landmarks: {
        name: 'Landmarks',
        getPath: (destination: ICommoDestination, type: CommonPageType) =>
            `/destination/${destination.state.code}/${destination.slug}/${type}/`,
    },
};

const CardViewMoreContainer = ({ destination, type }: CardViewMoreProps) => {
    const currentType = TYPES[type];
    const path = currentType.getPath(destination, type);

    return (
        <S.ViewMoreDesktop data-test-id="View_more">
            <S.TextWrapper>
                <S.SelectedTitle>{destination.name}</S.SelectedTitle>
                <S.SelectedExperience>
                    {destination.total_activities || destination.count_experiences} Experiences
                </S.SelectedExperience>
            </S.TextWrapper>
            <S.ButtonWrapper data-test-id="View_more_btn">
                <Link href={path.toLowerCase()} passHref>
                    <S.Button>
                        <span>
                            {`All ${destination.name}`}&nbsp;
                            {currentType.name}
                        </span>
                    </S.Button>
                </Link>
            </S.ButtonWrapper>
        </S.ViewMoreDesktop>
    );
};

export const CardViewMore = memo(CardViewMoreContainer);
